import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "@/components/ui/accordion";
import { useProductStore } from "@/store/product";
import { renderMultilineTextWithLinks } from "@/utils/linkify-text";

export function ProductAbout() {
	const { product } = useProductStore();

	return (
		<Accordion type="single" defaultValue="item-1" collapsible>
			<AccordionItem value="item-1">
				<AccordionTrigger>Descrição</AccordionTrigger>
				<AccordionContent>
					<div className="flex flex-col gap-2">
						{product?.description
							? renderMultilineTextWithLinks(product.description, {
								paragraphClassName:
									"font-inter text-P5 font-normal leading-160 text-neutral-500",
							})
							: "Nenhuma descrição disponível."}
					</div>
				</AccordionContent>
			</AccordionItem>

			<AccordionItem value="item-2">
				<AccordionTrigger>Regras</AccordionTrigger>
				<AccordionContent>
					<div className="flex flex-col gap-2">
						{product?.rules
							? renderMultilineTextWithLinks(product.rules, {
								paragraphClassName:
									"font-inter text-P5 font-normal leading-160 text-neutral-500",
							})
							: "Nenhuma regra disponível."}
					</div>
				</AccordionContent>
			</AccordionItem>

			<AccordionItem value="item-3">
				<AccordionTrigger>Premiações</AccordionTrigger>
				<AccordionContent>
					<div className="flex flex-col gap-2">
						{product?.awards
							? renderMultilineTextWithLinks(product.awards, {
								paragraphClassName:
									"font-inter text-P5 font-normal leading-160 text-neutral-500",
							})
							: "Nenhuma premiação disponível."}
					</div>
				</AccordionContent>
			</AccordionItem>

			<AccordionItem value="item-4">
				<AccordionTrigger>Projeção de ganho</AccordionTrigger>
				<AccordionContent>
					<div className="flex flex-col gap-2">
						{product?.earnings_projection
							? renderMultilineTextWithLinks(product.earnings_projection, {
								paragraphClassName:
									"font-inter text-P5 font-normal leading-160 text-neutral-500",
							})
							: "Nenhuma projeção de ganho disponível."}
					</div>
				</AccordionContent>
			</AccordionItem>
		</Accordion>
	);
}
